import type { EditorState } from "@tiptap/pm/state";
import { CoreExtensionNames } from "../constants/extention";

export const getParagraphCount = (editorState: EditorState | undefined) => {
  if (!editorState) return 0;
  let paragraphCount = 0;
  editorState.doc.descendants((node) => {
    if (
      // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison -- ?? why this is unsafe?
      node.type.name === CoreExtensionNames.PARAGRAPH &&
      node.content.size > 0
    )
      paragraphCount++;
  });
  return paragraphCount;
};
